import React, { useEffect, useState } from 'react';
import { InputProp } from '../../utils/tsConfig';

const CheckBox: React.FC<InputProp> = (props) => {
    const { 
        keyId, 
        setState, 
        state, 
        isArray, 
        indexVal, 
        arrayName, 
        returnKey, 
        width, 
        fieldName, 
        className, 
        options = [], 
        max, 
        min, 
        disabled = false, 
        required = false, 
        onChange 
    } = props;

    const [checked, setChecked] = useState<boolean>(false);

    // Get the current boolean value
    const getValue = (): boolean => {
        if (isArray && arrayName && indexVal !== undefined && returnKey) {
            return state?.[arrayName]?.[indexVal]?.[returnKey] || false;
        } else if (returnKey) {
            return state?.[returnKey] || false;
        } else {
            return state || false;
        }
    };

    // Update the boolean value
    const updateValue = (val: boolean) => {
        if (isArray && arrayName && indexVal !== undefined && returnKey && setState) {
            const updatedState = { ...state };
            if (!updatedState[arrayName]) updatedState[arrayName] = [];
            while (updatedState[arrayName].length <= indexVal) {
                updatedState[arrayName].push({});
            }
            updatedState[arrayName][indexVal][returnKey] = val;
            setState(updatedState);
        } else {
     
            // Update state if setState and returnKey are provided
            if (returnKey && setState) {
                setState({ ...state, [returnKey]: val });
            }
        }
    };

    // Handle checkbox toggle
    const handleToggle = () => {
        const newValue = !checked;
        setChecked(newValue);
        updateValue(newValue);
    };

    // Initialize state from props
    useEffect(() => {
        const val = getValue();
        setChecked(val);
    }, [state, returnKey, isArray, arrayName, indexVal]);

    return (
        <div className={`flex flex-col ${width || 'w-full'} ${className || ''}`}>
            {fieldName && (
                <label className="block text-sm font-medium text-gray-700 mb-1">
                    {fieldName.replace(/\*$/, '')}
                    {(required || fieldName.endsWith('*')) && <span className="text-red-500 ml-1">*</span>}
                </label>
            )}
            
            <div className="flex items-center">
                <input
                    id={keyId}
                    type="checkbox"
                    checked={checked}
                    onChange={handleToggle}
                    disabled={disabled}
                    className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                />
                <label htmlFor={keyId} className="ml-2 text-sm text-gray-700">
                    {fieldName?.replace(/\*$/, '') || 'Checkbox'}
                </label>
            </div>
        </div>
    );
};

export default CheckBox;